<template>
    <div class="modal-download-docs">
        <div class="modal-download-docs__back">
            <ui-trigger
                v-on:click="close"
                text="Назад"
                icon-left="caret-left"
                variant="dark"
                theme="secondary"
                is-underlined
            />
        </div>
        <div class="modal-download-docs__content">
            <div class="modal-download-docs__content-title"
                 v-text="title"
            />
<!--            <div class="modal-download-docs__content-items-header">
                <div>Дата</div>
                <div>Название документа</div>
            </div>-->
            <div class="modal-download-docs__content-items">
                <div class="modal-download-docs__content-items-item"
                     v-for="item in items"
                     v-bind:key="item.id"
                >
<!--                    <div class="_date">{{ item.created }}</div>-->
                    <div>{{ item.title }}</div>
                    <ui-button
                        class="_big-button"
                        v-bind:href="item.url"
                        v-bind:icon-left="'download'"
                        v-bind:theme="'transparent'"
                        v-bind:size="'xxs'"
                    >
                        Скачать
                    </ui-button>
                    <div class="_button">
                        <ui-button
                            v-bind:href="item.url"
                            v-bind:icon-left="'download'"
                            v-bind:theme="'transparent'"
                            v-bind:size="'xxs'"
                            is-width-free
                        />
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { date as commonDateTransform } from '~/network/mainClient/common/transforms/responses';

export default {
    name: 'modal-download-docs',
    props: {
        title: String,
        /**
         * @type {Array<{id: number, title: string, url: string, created: string}>}
         */
        items: Array,
    },
    computed: {
        // formattedItems() {
        //     return this.items.map(item => ({
        //         ...item,
        //         created: commonDateTransform(item.created),
        //     }));
        // },
    },
    methods: {
        close() {
            this.$store.commit('modals/pop');
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.modal-download-docs {
    // .modal();
    flex: 1;
    width: 100%;
    padding: 16px;
    background-color: @color-gray-lighter;

    @media @media-md-down {
        padding: 0;
    }

    &__back {
        position: absolute;
        left: 32px;
        top: 16px;

        @media @media-md-down {
            display: none;
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        gap: 20px;
        width: 100%;
        max-width: 820px;
        margin: 0 auto;

        &-title {
            .typography-large();

            @media @media-sm-down {
                .typography-heading();
            }
        }

        /* &-items-header {
            display: grid;
            grid-template-columns: 100px 1fr;
            padding: 0 16px;

            .typography-caption();

            text-transform: uppercase;
            color: @color-gray-main;

            @media @media-sm-down {
                display: none;
            }
        } */

        &-items {
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 8px;

            &-item {
                position: relative;

                display: grid;
                grid-template-columns: 1fr 120px;
                align-items: center;

                width: 100%;
                padding: 16px;

                background-color: @color-gray-lightest;

                border-radius: @border-radius-lg;
                border: 1px solid @color-gray-light;

                .typography-body();

                @media @media-sm-down {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    padding-right: 48px;
                }

                & ._date {
                    color: @color-gray-main;
                }

                & ._big-button {
                    @media @media-sm-down {
                        display: none;
                    }
                }

                & ._button {
                    display: none;
                    position: absolute;

                    @media @media-sm-down {
                        display: block;
                        right: 8px;
                        top: 8px;
                    }
                }
            }
        }
    }
}
</style>
